var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarHome1Active(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7313 7.15302L8.55262 0.611843C8.23752 0.324688 7.76237 0.324719 7.4474 0.611812L0.268689 7.15305C0.0162826 7.38305 -0.0670923 7.73742 0.0562201 8.05583C0.179564 8.37423 0.479876 8.57995 0.821344 8.57995H1.96791V15.1337C1.96791 15.3936 2.17859 15.6043 2.43844 15.6043H6.37325C6.63309 15.6043 6.84378 15.3936 6.84378 15.1337V11.1545H9.15634V15.1338C9.15634 15.3936 9.36702 15.6043 9.62687 15.6043H13.5615C13.8213 15.6043 14.032 15.3936 14.032 15.1338V8.57995H15.1788C15.5202 8.57995 15.8206 8.3742 15.9439 8.05583C16.0671 7.73739 15.9837 7.38305 15.7313 7.15302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.909 1.33496H10.749L14.3795 4.63608V1.80546C14.3795 1.54562 14.1689 1.33496 13.909 1.33496Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarHome1Active);
export default __webpack_public_path__ + "static/media/sidebar-home-1-active.ecb755f58246ee4005f531f0d5fbc3c0.svg";
export { ForwardRef as ReactComponent };